<template>
    <div class="fullname safe-distance-top">
        <div class="fullname_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <div class="my">上传{{ $route.query.label }}</div>
            <div class="determine" @click="setSave">确定</div>
        </div>
        <div class="fullname_bottm">
            <van-uploader
                v-for="item in keyArr"
                :key="item"
                :max-size="1 * 1024 * 1024"
                :before-read="beforeRead"
                :after-read="(file) => clzpAfterRead(file, item)"
                @oversize="onOversize"
            >
                <div
                    class="upload_card_box"
                    v-if="item === 'operateIdentityImgFront' || item === 'operateIdentityImgBack'"
                >
                    <img
                        v-if="userInfoObj[item]"
                        class="upload_img"
                        :src="$global.imgUrl + userInfoObj[item]"
                        alt=""
                    />
                    <img
                        v-else
                        class="upload_default_img"
                        :src="require(`@/assets/img/mobile-img/${defaultImgFilter(item)}.png`)"
                        alt=""
                    />
                </div>
                <div class="upload_box" v-else>
                    <img
                        v-if="userInfoObj[item]"
                        class="upload_img"
                        :src="$global.imgUrl + userInfoObj[item]"
                        alt=""
                    />
                    <div v-else class="upload_default_box">
                        <img
                            class="upload_icon"
                            :src="require(`@/assets/img/mobile-img/upload_icon.png`)"
                            alt=""
                        />
                        <p class="upload_tip">上传{{ $route.query.label }}</p>
                    </div>
                </div>
            </van-uploader>
        </div>
    </div>
</template>

<script>
import { Toast } from "vant";
export default {
    name: "imgEdit",
    data() {
        return {
            userInfoObj: {},
            keyArr: [],
        };
    },
    created() {
        // 已认证完成
        let pageQuery = this.$route.query;
        this.keyArr = pageQuery.key.split(",");
        if (sessionStorage.getItem(pageQuery.objName)) {
            this.userInfoObj = JSON.parse(sessionStorage.getItem(pageQuery.objName));
        }
    },
    methods: {
        defaultImgFilter(name) {
            switch (name) {
                case "operateIdentityImgFront":
                    return "idcard_top";
                case "operateIdentityImgBack":
                    return "idcard_back";
            }
        },
        to() {
            window.history.go(-1);
        },
        setSave() {
            let pageQuery = this.$route.query;
            if (this.keyArr.every((item) => this.userInfoObj[item])) {
                sessionStorage.setItem(pageQuery.objName, JSON.stringify(this.userInfoObj));
                window.history.go(-1);
            } else {
                Toast("图片未上传完整,请重新上传");
            }
        },

        //校验上传图片大小
        onOversize(file) {
            Toast("文件大小不能超过1MB");
        },
        //校验图片的格式
        beforeRead(file) {
            if (!/(jpg|jpeg|png|JPG|PNG)/i.test(file.type)) {
                Toast("仅支持JPG、JPEG、PNG格式");
                return false;
            }
            return true;
        },

        //照片上传事件方法
        async clzpAfterRead(file, key) {
            // 创建一个空对象实例
            let formData = new FormData();
            // 调用append()方法添加数据
            formData.append("file", file.file);
            const res = await this.$apis.myServe.uploadFileMannual(formData);
            this.$set(this.userInfoObj, key, res.data);
        },
    },
};
</script>

<style lang="scss" scoped>
.fullname {
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;

    .fullname_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
        align-content: center;
        position: relative;

        .my {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            background: #fff;
            text-align: center;
        }

        .determine {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            position: absolute;
            right: 15px;
        }
    }

    .fullname_bottm {
        display: flex;
        justify-content: space-between;
        padding: 15px;

        .upload_box,
        .upload_card_box {
            width: 166px;
            height: 105px;
            background-color: #f9f9f9;
            border-radius: 6px;
            overflow: hidden;

            .upload_img {
                width: 100%;
                height: 100%;
            }
            .upload_default_box {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                width: 100%;
                height: 100%;
            }

            .upload_default_img {
                padding: 6px;
                width: 100%;
                height: 100%;
            }

            .upload_icon {
                width: 18px;
                height: 17px;
            }

            .upload_tip {
                margin-top: 10px;
                font-size: 13px;
                color: #999999;
                line-height: 19px;
            }
        }

        .upload_card_box {
            background-color: #f7f9ff;
        }
    }
}
</style>
